import gql from 'graphql-tag';

const query = gql`
    query Settings {
        me {
            id
            email
            name
            sex
            height {
                value
                unit
            }
            goalWeight {
                value
                unit
            }
            birthDate
            measurement {
                weight(request: { limit: 1 }) {
                    value
                    unit
                }
            }
            systemOfMeasures
            hasRegisteredDevices
            passwordIsSet
            hasExternalProviderSetUp
            isAbleToLoginWithFacebook
            isAbleToLoginWithGoogle
            isAbleToLoginWithApple
            agreements {
                dietCourse
                articles
                newsletter
            }
            diet {
                accessTo
                lifetimeAccess
                mode
            }
            videoWorkout {
                accessTo
                lifetimeAccess
            }
            activeSubscriptions {
                givesAccessToDiet
                givesAccessToVideoWorkouts
                renewalDate
                operator
            }
            hydrationSettings {
                key
                defaultDailyGoal {
                    value
                    unit
                }
                notifications {
                    key
                    enabled
                    hourInterval
                    fromHour
                    toHour
                    useSound
                }
            }
        }
    }
`;

export default query;
